import { Component, Inject, OnInit, Optional } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from 'app/services/dialog.service';
import { IconService } from 'app/services/icon.service';
import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-project-icon-selector',
  templateUrl: './project-icon-selector.component.html',
  styleUrls: ['./project-icon-selector.component.scss'],
  standalone: false,
})
export class ProjectIconSelectorDialogComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  public selectedUrl: string;
  public projectIconList: string[] = [];

  constructor(
    private dialogRef: MatDialogRef<ProjectIconSelectorDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public iconUrl: string,
    private iconService: IconService
  ) {}

  ngOnInit(): void {
    this.refresh();
    if (this.iconUrl) {
      this.selectedUrl = this.getProjectIcon(this.iconUrl);
    } else {
      const min = Math.ceil(0);
      const max = Math.floor(this.projectIconList.length - 1);
      const iconIdx = Math.floor(Math.random() * (max - min + 1)) + min;
      this.selectedUrl = this.getProjectIcon(this.projectIconList[iconIdx]);
    }
  }

  private refresh() {
    this.projectIconList = this.iconService.listByType('project-icons');
  }

  public getSelectedUrl(): string {
    return this.getProjectIcon(this.selectedUrl);
  }

  public cancel(): void {
    this.dialogRef.close({ iconUrl: this.iconUrl });
  }

  public select(): void {
    this.dialogRef.close({ iconUrl: this.selectedUrl });
  }

  public updateSelectedUrl(updated: string): void {
    this.selectedUrl = updated;
    this.refresh();
  }

  public getProjectIcon(id: string): string {
    return this.iconService.getByTypeAndId('project-icons', id);
  }
}
